import { useEffect, useRef } from "react";
import { api_private_get, api_private_post, showAlert } from "script";

export default function PreferencesTab() {
  const hideBalanceRef = useRef(null);
  const darkModeRef = useRef(null);
  const languageRef = useRef(null);
  const timeZoneRef = useRef(null);
  const oddsFormatRef = useRef(null);
  const maxInactivityTimeRef = useRef(null);

  useEffect(() => {
    // Fetch initial preferences and set the state of the checkboxes and selects
    api_private_get("/account/get_preferences", (data) => {
      // console.log("Preferences data:", data);
      if (hideBalanceRef.current)
        hideBalanceRef.current.checked = data.show_balance;
      if (darkModeRef.current) darkModeRef.current.checked = data.dark_mode;
      if (languageRef.current) languageRef.current.value = data.language;
      if (timeZoneRef.current) timeZoneRef.current.value = data.time_zone;
      if (oddsFormatRef.current)
        oddsFormatRef.current.value = data.odds_display;
      if (maxInactivityTimeRef.current)
        maxInactivityTimeRef.current.value = data.max_inactivity_time;
    });
  }, []);

  const handleHideBalanceChange = (e) => {
    api_private_post(
      "/account/set_preferences",
      { show_balance: e.target.checked },
      () => showAlert("Preference saved!", "success"),
    );
  };

  const handleDarkModeChange = (e) => {
    api_private_post(
      "/account/set_preferences",
      { dark_mode: e.target.checked },
      () => showAlert("Preference saved!", "success"),
    );
  };

  const handleLanguageChange = (e) => {
    api_private_post(
      "/account/set_preferences",
      { language: e.target.value },
      () => showAlert("Preference saved!", "success"),
    );
  };

  const handleMaxInactivityTimeChange = (e) => {
    api_private_post(
      "/account/set_preferences",
      { max_inactivity_time: e.target.value },
      () => showAlert("Preference saved!", "success"),
    );
  };

  const handleTimeZoneChange = (e) => {
    api_private_post(
      "/account/set_preferences",
      { time_zone: e.target.value },
      () => showAlert("Preference saved!", "success"),
    );
  };

  const handleOddsFormatChange = (e) => {
    api_private_post(
      "/account/set_preferences",
      { odds_display: e.target.value },
      () => showAlert("Preference saved!", "success"),
    );
  };

  return (
    <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8">
      <style>
        {`
                    .my-select {
                        background-color: #e8eeff;
                        border: 1px solid rgba(42, 50, 58, 0.8);
                        border-radius: 8px;
                        float: right;
                    }
                `}
      </style>
      <div className="pay_method__paymethod-title d-flex align-items-center gap-3 mb-6 mb-md-8">
        <i className="ti ti-settings fs-four"></i>
        <h5 className="n10-color">Preferences </h5>
      </div>
      <div className="pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Language</h6>
          <span className="fs-seven n4-color">
            Change the language of the text displayed on the website.
          </span>
          <p className="fs-seven n4-color mt-2 text-warning">
            Only English is available for the moment. Russian and French are
            coming soon!
          </p>
        </div>
        <div className="w-50 mb-3">
          <select
            className="my-select"
            id="language-select"
            ref={languageRef}
            onChange={handleLanguageChange}
          >
            {/* <!-- <option>Your language...</option> --> */}
            <option value="en">English</option>
            <option value="cn">Chinese</option>
            <option value="es">Espanol</option>
            <option value="fr">Francais</option>
            <option value="pt">Portugues</option>
            <option value="ru">Russian</option>
          </select>
        </div>
      </div>
      <div className="pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Time Zone</h6>
          <span className="fs-seven n4-color">
            The the time zone when displaying the time on the website.
          </span>
        </div>
        <div className="w-50 mb-3">
          <select
            className="my-select"
            id="time-zone-select"
            ref={timeZoneRef}
            onChange={handleTimeZoneChange}
          >
            <option value="uk">UK</option>
            <option value="et">ET</option>
            <option value="pt">PT</option>
            <option value="cet">CET</option>
            <option value="ct">CT</option>
            <option value="mt">MT</option>
            <option value="gmt-12">GMT-12</option>
            <option value="gmt-11">GMT-11</option>
            <option value="gmt-10">GMT-10</option>
            <option value="gmt-9">GMT-9</option>
            <option value="gmt-8">GMT-8</option>
            <option value="gmt-7">GMT-7</option>
            <option value="gmt-6">GMT-6</option>
            <option value="gmt-5">GMT-5</option>
            <option value="gmt-4">GMT-4</option>
            <option value="gmt-3">GMT-3</option>
            <option value="gmt-2">GMT-2</option>
            <option value="gmt-1">GMT-1</option>
            <option value="gmt">GMT</option>
            <option value="gmt+1">GMT+1</option>
            <option value="gmt+2">GMT+2</option>
            <option value="gmt+3">GMT+3</option>
            <option value="gmt+4">GMT+4</option>
            <option value="gmt+5">GMT+5</option>
            <option value="gmt+6">GMT+6</option>
            <option value="gmt+7">GMT+7</option>
            <option value="gmt+8">GMT+8</option>
            <option value="gmt+9">GMT+9</option>
            <option value="gmt+9.5">GMT+9.5</option>
            <option value="gmt+10">GMT+10</option>
            <option value="gmt+10.5">GMT+10.5</option>
            <option value="gmt+11">GMT+11</option>
            <option value="gmt+12">GMT+12</option>
            <option value="gmt+13">GMT+13</option>
            <option value="eet">EET</option>
            <option value="por">POR</option>
          </select>
        </div>
      </div>
      <div className="pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Odds Display</h6>
          <span className="fs-seven n4-color">
            Choose which format the odds are displayed throughout the website.
          </span>
          <p className="fs-seven n4-color mt-2 text-warning">
            This feature is coming soon!
          </p>
        </div>
        <div className="w-50 mb-3">
          <select
            className="my-select"
            id="odds-format-select"
            ref={oddsFormatRef}
            onChange={handleOddsFormatChange}
          >
            <option value="decimal">Decimal</option>
            <option value="fractional">Fractional</option>
            <option value="american">American</option>
          </select>
        </div>
      </div>
      <div className="pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Max Inactivity Time</h6>
          <span className="fs-seven n4-color">
            Choose after how much time that you will be automatically logged
            off. It applied on your next login.
          </span>
        </div>
        <div className="w-50 mb-3">
          <select
            className="my-select"
            id="max-inactivity-time-select"
            ref={maxInactivityTimeRef}
            onChange={handleMaxInactivityTimeChange}
          >
            <option value="5">5 minutes</option>
            <option value="10">10 minutes</option>
            <option value="15">15 minutes</option>
            <option value="20">20 minutes</option>
            <option value="25">25 minutes</option>
            <option value="30">30 minutes</option>
            <option value="35">35 minutes</option>
            <option value="40">40 minutes</option>
            <option value="45">45 minutes</option>
            <option value="50">50 minutes</option>
            <option value="55">55 minutes</option>
            <option value="60">60 minutes</option>
          </select>
        </div>
      </div>
      <div className="disabled-element pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Hide Balance</h6>
          <span className="fs-seven n4-color">
            Hide the balance amounts when on.
          </span>
          <p className="fs-seven n4-color mt-2 text-warning">
            This feature is coming soon!
          </p>
        </div>
        <div className="pay_method__Notiitem-switcher">
          <label className="switch">
            <input
              type="checkbox"
              id="hide-balance-checkbox"
              ref={hideBalanceRef}
              onChange={handleHideBalanceChange}
            />
            <div className="slider">
              <div className="circle">
                <svg
                  className="cross"
                  xmlSpace="preserve"
                  style={{ enableBackground: "new 0 0 512 512" }}
                  viewBox="0 0 365.696 365.696"
                  y="0"
                  x="0"
                  height="6"
                  width="6"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      data-original="#000000"
                      fill="currentColor"
                      d="M243.188 182.86 356.32 69.726c12.5-12.5 12.5-32.766 0-45.247L341.238 9.398c-12.504-12.503-32.77-12.503-45.25 0L182.86 122.528 69.727 9.374c-12.5-12.5-32.766-12.5-45.247 0L9.375 24.457c-12.5 12.504-12.5 32.77 0 45.25l113.152 113.152L9.398 295.99c-12.503 12.503-12.503 32.769 0 45.25L24.48 356.32c12.5 12.5 32.766 12.5 45.247 0l113.132-113.132L295.99 356.32c12.503 12.5 32.769 12.5 45.25 0l15.081-15.082c12.5-12.504 12.5-32.77 0-45.25zm0 0"
                    ></path>
                  </g>
                </svg>
                <svg
                  className="checkmark"
                  xmlSpace="preserve"
                  style={{ enableBackground: "new 0 0 512 512" }}
                  viewBox="0 0 24 24"
                  y="0"
                  x="0"
                  height="10"
                  width="10"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      className=""
                      data-original="#000000"
                      fill="currentColor"
                      d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div className="disabled-element pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Number Comma Format</h6>
          <span className="fs-seven n4-color">
            Choose how numbers will be displayed.
          </span>
          <p className="fs-seven n4-color mt-2 text-warning">
            This feature is coming soon!
          </p>
        </div>
        <div className="w-50 mb-3">
          <select className="my-select" id="number-format-select">
            <option value="">123,456.78</option>
            <option value="">123.456,78</option>
            <option value="">123456.78</option>
            <option value="">123456,78</option>
            <option value="">123 456.78</option>
            <option value="">123 456,78</option>
          </select>
        </div>
      </div>
      <div className="disabled-element pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center pb-5 pb-md-6 mb-5 mb-md-6">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Currency Symbol Format</h6>
          <span className="fs-seven n4-color">
            Choose how currencies will be displayed.
          </span>
          <p className="fs-seven n4-color mt-2 text-warning">
            This feature is coming soon!
          </p>
        </div>
        <div className="w-50 mb-3">
          <select className="my-select" id="currency-format-select">
            <option value="">123 USD</option>
            <option value="">USD 123</option>
            <option value="">USD123</option>
            <option value="">$123</option>
            <option value="">123$</option>
            <option value="">US$123</option>
            <option value="">123$US</option>
          </select>
        </div>
      </div>
      <div className="disabled-element pay_method__Notiitem d-flex align-items-center gap-3 justify-content-between align-items-center border-0">
        <div className="pay_method__Notiitem-text">
          <h6 className="mb-3">Dark mode</h6>
          <span className="fs-seven n4-color">
            Enables a darker design for the website.
          </span>
          <p className="fs-seven n4-color mt-2 text-warning">
            This feature is coming soon!
          </p>
        </div>
        <div className="pay_method__Notiitem-switcher">
          <label className="switch">
            <input
              type="checkbox"
              id="dark-mode-checkbox"
              ref={darkModeRef}
              onChange={handleDarkModeChange}
            />
            <div className="slider">
              <div className="circle">
                <svg
                  className="cross"
                  xmlSpace="preserve"
                  style={{ enableBackground: "new 0 0 512 512" }}
                  viewBox="0 0 365.696 365.696"
                  y="0"
                  x="0"
                  height="6"
                  width="6"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      data-original="#000000"
                      fill="currentColor"
                      d="M243.188 182.86 356.32 69.726c12.5-12.5 12.5-32.766 0-45.247L341.238 9.398c-12.504-12.503-32.77-12.503-45.25 0L182.86 122.528 69.727 9.374c-12.5-12.5-32.766-12.5-45.247 0L9.375 24.457c-12.5 12.504-12.5 32.77 0 45.25l113.152 113.152L9.398 295.99c-12.503 12.503-12.503 32.769 0 45.25L24.48 356.32c12.5 12.5 32.766 12.5 45.247 0l113.132-113.132L295.99 356.32c12.503 12.5 32.769 12.5 45.25 0l15.081-15.082c12.5-12.504 12.5-32.77 0-45.25zm0 0"
                    ></path>
                  </g>
                </svg>
                <svg
                  className="checkmark"
                  xmlSpace="preserve"
                  style={{ enableBackground: "new 0 0 512 512" }}
                  viewBox="0 0 24 24"
                  y="0"
                  x="0"
                  height="10"
                  width="10"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      className=""
                      data-original="#000000"
                      fill="currentColor"
                      d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}
